import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FullModeService } from 'src/app/services/full-mode.service';

@Component({
  selector: 'product-sync-manager-component',
  templateUrl: './product-sync-manager.component.html',
  styleUrls: ['./product-sync-manager.component.scss']
})
export class ProductSyncManagerComponent implements OnInit {
  logoImg: string = `../../../assets/imgs/logo/se2in_logo.png`;
  titleSectionProp: any = {
    class: 'iq-title-box-2',
    title: 'We lead and support our customer’s cloud',
    description: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.'
  };
  constructor(
    public translate: TranslateService,
    public route:ActivatedRoute,
    public fullModeService:FullModeService
  ) { }
  List: any[] = [
    { title: 'Boost SEO ranking' },
    { title: 'Social Sharing' },
    { title: 'Marketing' },
    { title: 'Retention' },
    { title: 'Visual Reviews' },
    { title: 'Reviews Generation' }
  ];
  List1: any[] = [
    { title: 'Engineers and Developers', content: '', timer: 50, currentValue: 0, symbol: '+' },
    { title: 'Customers', content: 'k', timer: 100, currentValue: 0, symbol: '+' }
  ];
  List2: any[] = [
    { title: 'Instances Deployed', content: 'm', timer: 35, currentValue: 0, symbol: '+' },
    { title: 'Support answers per month', content: 'm', timer: 15, currentValue: 0, symbol: '+' }
  ]
  currentApp:any={}
  designer={
    title: 'DESIGNER',desc: 'DESIGNER_DESCRIPTION', class: 'text-center iq-title-box-2', link:'designer',
    navList:[
      {
        id: 'tab-one-click-deploy',
        title: 'FREE_CONSTANT_DESIGNER',
        sub_title:"",
        image:"./assets/images/se-icons/free.png",
        content_image:"./assets/downloads/app-preview/designer/designer-mac-",
        active: 'active'
      },
      {
        id: 'tab-powerful-api',
        title: 'BUILD_WEBSITE_DESIGNER',
        sub_title:"",
        image:"./assets/images/se-icons/designer-web.png",
        content_image:"./assets/downloads/app-preview/designer/designer-mac-",
        active: ''
      },
      {
        id: 'tab-easy-management',
        title: 'DESIGN_APP_DESIGNER',
        sub_title:"",
        image:"./assets/images/se-icons/designer-app.png",
        content_image:"./assets/downloads/app-preview/designer/designer-mac-",
        active: ''
      },
      {
        id: 'tab-help-desk-services',
        title: 'HOSTING_DESIGNER',
        sub_title:"",
        image:"./assets/images/se-icons/host-app.png",
        content_image:"./assets/downloads/app-preview/designer/designer-mac-",
        active: ''

      }
    ]
  }
  creator={
    title: 'PRODUCT_SYNC_CREATOR_MODE_TRUE', desc: 'CREATOR_DESCRIPTION', class: 'text-center iq-title-box-2', link:'se2sync-creator',
    navList:[
      {
        id: 'tab-powerful-api',
        title: 'FREE_CONSTANT_CREATOR',
        sub_title:"",
        image:"./assets/images/se-icons/ai-programming.png",
        content_image:"./assets/downloads/app-preview/creator/creator-mac-",
        active: ''
      },
      {
        id: 'tab-one-click-deploy',
        title: 'SYNC_CONFIG_CREATOR',
        sub_title:"",
        image:"./assets/images/se-icons/cloud-it-department.png",
        content_image:"./assets/downloads/app-preview/creator/creator-mac-",
        active: 'active'
      },
      {
        id: 'tab-easy-management',
        title: 'BILLING_SOFTWARE_CREATOR',
        sub_title:"",
        image:"./assets/images/se-icons/designer-web.png",
        content_image:"./assets/downloads/app-preview/creator/creator-mac-",
        active: ''
      },
      {
        id: 'tab-help-desk-services',
        title: 'BACKUP_SOFTWARE_CREATOR',
        sub_title:"",
        image:"./assets/images/se-icons/cloud-database.png",
        content_image:"./assets/downloads/app-preview/creator/creator-mac-",
        active: ''

      }
    ]
  }
  backoffice={
    title: 'BACKOFFICE',desc: 'BACKOFFICE_LONG_DESCRIPTION', class: 'text-center iq-title-box-2', link:'backoffice',
    navList:[
      {
        id: 'tab-one-click-deploy',
        title: 'FREE_CONSTANT_BACKOFFICE',
        sub_title:"",
        image:"./assets/images/se-icons/free.png",
        content_image:"./assets/downloads/app-preview/backoffice/backoffice-mac-",
        active: 'active'
      },
      {
        id: 'tab-powerful-api',
        title: 'USER_ADMIN_BACKOFFICE',
        sub_title:"",
        image:"./assets/images/se-icons/user-administration.png",
        content_image:"./assets/downloads/app-preview/backoffice/backoffice-mac-",
        active: ''
      },
      {
        id: 'tab-easy-management',
        title: 'EVENT_AND_SHOP_ADMIN_BACKOFFICE',
        sub_title:"",
        image:"./assets/images/se-icons/user-administration.png",
        content_image:"./assets/downloads/app-preview/backoffice/backoffice-mac-",
        active: ''
      },
      {
        id: 'tab-help-desk-services',
        title: 'EVENT_YOUR_BACKOFFICE',
        sub_title:"",
        image:"./assets/images/se-icons/business-logic.png",
        content_image:"./assets/downloads/app-preview/backoffice/backoffice-mac-",
        active: ''

      }
    ]
  }
  se2syncApi={
    title: 'PRODUCT_SYNC_API',desc: 'SYNC_API_DESCRIPTION', class: 'text-center iq-title-box-2', link:'se2sync-api',
    navList:[
      {
        id: 'tab-one-click-deploy',
        title: 'FREE_CONSTANT_PRODUCT_SYNC_API',
        sub_title:"It is a long established fact that a reader will be distracted.",
        image:"./assets/images/tab/02-2.png",
        content_image:"./assets/images/tab/01.png",
        active: 'active'
      },
      {
        id: 'tab-powerful-api',
        title: 'SYNC_CONFIG_PRODUCT_SYNC_API',
        sub_title:"It is a long established fact that a reader will be distracted.",
        image:"./assets/images/tab/02-2.png",
        content_image:"./assets/images/tab/02.png",
        active: ''
      },
      {
        id: 'tab-easy-management',
        title: 'BILLING_SOFTWARE_PRODUCT_SYNC_API',
        sub_title:"It is a long established fact that a reader will be distracted.",
        image:"./assets/images/tab/03-3.png",
        content_image:"./assets/images/tab/03.png",
        active: ''
      },
      {
        id: 'tab-help-desk-services',
        title: 'BACKUP_SOFTWARE_PRODUCT_SYNC_API',
        sub_title:"It is a long established fact that a reader will be distracted.",
        image:"./assets/images/tab/04-4.png",
        content_image: "./assets/images/tab/04.png",
        active: ''

      }
    ]
  }

  se2syncManager={
    title: 'PRODUCT_SYNC_CREATOR_MODE_FALSE',desc: 'SYNC_CREATOR_DESCRIPTION',class: 'text-center iq-title-box-2', link:'se2sync-creator',
    navList:[
      {
        id: 'tab-one-click-deploy',
        title: 'FREE_CONSTANT_PRODUCT_SYNC_CREATOR_MODE_FALSE',
        sub_title:"It is a long established fact that a reader will be distracted.",
        image:"./assets/images/se-icons/free.png",
        content_image:"./assets/downloads/app-preview/creator/creator-mac-",
        active: 'active'
      },
      {
        id: 'tab-powerful-api',
        title: 'SYNC_CONFIG_PRODUCT_SYNC_CREATOR_MODE_FALSE',
        sub_title:"It is a long established fact that a reader will be distracted.",
        image:"./assets/images/se-icons/cloud-it-department.png",
        content_image:"./assets/downloads/app-preview/creator/creator-mac-",
        active: ''
      },
      {
        id: 'tab-easy-management',
        title: 'BILLING_SOFTWARE_PRODUCT_SYNC_CREATOR_MODE_FALSE',
        sub_title:"It is a long established fact that a reader will be distracted.",
        image:"./assets/images/se-icons/billing.png",
        content_image:"./assets/downloads/app-preview/creator/creator-mac-",
        active: ''
      },
      {
        id: 'tab-help-desk-services',
        title: 'BACKUP_SOFTWARE_PRODUCT_SYNC_CREATOR_MODE_FALSE',
        sub_title:"It is a long established fact that a reader will be distracted.",
        image:"./assets/images/se-icons/database-backup.png",
        content_image:"./assets/downloads/app-preview/creator/creator-mac-",
        active: ''

      }
    ]
  }


  ngOnInit(): void {
    this.startCounters();
  }

  startCounters(): void {
    const duration = 5000;
    const intervalTime = 100;
    const steps = duration / intervalTime;
    [...this.List1, ...this.List2].forEach((list) => {
      const increment = list.timer / steps;
      let currentValue = 0;
      const interval = setInterval(() => {
        currentValue += increment;
        list.currentValue = currentValue
        if (currentValue >= list.timer) {
          currentValue = list.timer;
          clearInterval(interval);
        }
        list.currentValue = Math.floor(currentValue)
      }, intervalTime);
    });
  }
  ngAfterViewInit(): void {
    if(window.location.href.includes('designer')){
      this.currentApp = this.designer;
    }else if( window.location.href.includes('creator')){
      if(this.fullModeService.fullMode){
        this.currentApp = this.creator;
      }else{
        this.currentApp = this.se2syncManager;
      }
    }else if( window.location.href.includes('backoffice')){
      this.currentApp = this.backoffice;
    }else if(window.location.href.includes('se2sync-api')){
      this.currentApp = this.se2syncApi;
    }else{
      this.currentApp = this.se2syncManager;
    }
  }

}
